import { http } from "config/http";

// import { ConfigPayload } from "pages/inventory-forecast-configuration"

function getFormData(object:any) {
    const formData = new FormData();
    Object.keys(object).forEach(key => object[key] ? formData.append(key, object[key]) : formData.append(key, ""));
    return formData;
}


export const postInventoryConfigData= async (firstFormData : any) => {

    
    const data = getFormData(firstFormData)

    try {
        const res: any = await http.post(`save_forecast_config`, data);
     
        return { result: res?.data}
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getInventoryConfigData= async () => {

    try {
        const res: any = await http.get(`get_latest_admin_config?client_env=${localStorage.getItem("clientName")}`);
     
        return { result: res?.data.data}
    } catch (error: any) {
        return { error: error.message }
    }
}